import React, { FC } from "react";
import { Branding, FooterBrandingProps } from "./Branding";
import { Navigation } from "./Navigation";
import { FooterNavigationLinkProps } from "./NavigationLinks";
import { Copyright, FooterCopyrightProps } from "./Copyright";
import { StyledBrandingAndNav, StyledContent } from "./index.styled";

export interface FooterProps {
  branding: FooterBrandingProps;
  copyright: FooterCopyrightProps;
  navigation: FooterNavigationLinkProps[];
}

/**
 * The footer consists of 3 sections:
 * 1. Branding + social media, which is a smaller logo plus icons with links to its various social media.
 * 2. List of links, with an optional category name on top (e.g., SHOP: Product Bundles, Sports Drinks, etc.).
 * 3. Copyright.
 */
export const Footer: FC<FooterProps> = ({
  branding,
  copyright,
  navigation,
}) => {
  return (
    <footer data-testid="footer">
      <StyledContent>
        <StyledBrandingAndNav>
          <Branding {...branding} />
          <Navigation navigation={navigation} />
        </StyledBrandingAndNav>
      </StyledContent>
      <Copyright {...copyright} />
    </footer>
  );
};
